var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.show)?_c('div',{staticClass:"loader"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"spinner","spin":""}}),_vm._v("Loading... ")],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }